// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___SPHtSOowTfm","title":"title__uqnM82IGU1tg","link":"link__Fk6Nf_Gzhpjk","positive":"positive__qQA7PokEHDxw","warning":"warning__Hbyk2jTw_U0z"};